<template>
  <div class="back-closd-link">
    <a
      :href="$t('login.BackToClosd.urlClosd')"
      data-locator="back-to-closd-link"
      class="text-text-tertiary body-md-bold"
    >
      {{$t('login.BackToClosd.backClosd')}}
    </a>
  </div>
</template>

<script>
export default {
  name: 'BackToClosd',
}
</script>

<style scoped>
.back-closd-link a {
  text-decoration: none;
}
</style>
